// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

/**
 * Schema for item field card drag-and-drop data.
 */
const itemFieldCardDataSchema = z.object({
  type: z.literal('field'),
  index: z.number(),
});

export type ItemFieldCardData = z.infer<typeof itemFieldCardDataSchema>;

/**
 * Checks if a value is an ItemFieldCardData object.
 */
export function isItemFieldCardData(data: unknown): data is ItemFieldCardData {
  const result = itemFieldCardDataSchema.safeParse(data);
  return result.success;
}

/**
 * Schema for item field section drag-and-drop data.
 */
const itemFieldSectionDataSchema = z.object({
  type: z.literal('section'),
  index: z.number(),
});

export type ItemFieldSectionData = z.infer<typeof itemFieldSectionDataSchema>;

/**
 * Checks if a value is an ItemFieldSectionData object.
 */
export function isItemFieldSectionData(
  data: unknown
): data is ItemFieldSectionData {
  const result = itemFieldSectionDataSchema.safeParse(data);
  return result.success;
}
